import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		actions: {
			padding: "16px 24px",
		},
	} satisfies Record<string, CSSObject>);
